import { Grid, Typography } from "@mui/material";
import { useStyles } from "../Common/CommonStyle";
import excellarateLogo from "../../images/Excellarate logo 8.svg";
import incompatibleDevice from "../../images/incompatibleDevice.svg";
import laptop from "../../images/laptop.svg";
import desktop from "../../images/desktop.svg";
import tablet from "../../images/tablet.svg";

export const IncompatibleDevice = () => {
  const classes = useStyles();

  return (
    <Grid container className={classes.positionComponent} sx={{ background: '#fff', height: '100vh', padding: '40px 24px' }}>
      <Grid item xs={12}>
        <img src={excellarateLogo} alt="logo" />
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <img src={incompatibleDevice} alt="incompatible device" />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h3" sx={{ fontWeight: 600, fontSize: '24px', lineHeight: '28px', marginTop: '2rem', color: '#1E1F4A' }}>Incompatible device!</Typography>
        <Typography sx={{ fontWeight: 400, fontSize: '14px', marginTop: '1rem', color: '#1E1F4A' }}>Please use a desktop, tablet or laptop to explore the metaverse experience. WebGL is not currently supported on mobile device.</Typography>
      </Grid>
      <Grid item xs={12} sx={{ borderTop: '1px solid #DCDCDC' }}>
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography sx={{ fontWeight: 400, fontSize: '16px', marginTop: '1rem', color: '#848484' }}>Try opening in</Typography>
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <img src={desktop} alt="desktop" style={{ height: '45px', width: 'auto' }} />
        <img src={laptop} alt="laptop" style={{ height: '45px', width: 'auto' }} />
        <img src={tablet} alt="tablet" style={{ height: '45px', width: 'auto' }} />
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{ fontWeight: 400, fontSize: '14px', marginTop: '1rem', color: '#888888;' }}>© 2022 Excellarate. All Rights Reserved</Typography>
      </Grid>
    </Grid>
  );
};
